"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f8225 = void 0;
exports.f8225 = {
    "‡ungkue": [
        2673
    ],
    "‡hoan": [
        3073
    ],
    "‡hoa": [
        3073
    ],
    "‡hoã": [
        3073
    ],
    "‡hua": [
        3073
    ],
    "‡hua-owani": [
        3073
    ],
    "‡khomani": [
        5427
    ]
};
